import { render, staticRenderFns } from "./configServers.vue?vue&type=template&id=598541b5&"
import script from "./configServers.vue?vue&type=script&lang=js&"
export * from "./configServers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports